import { render } from "./ClientesAdmin.vue?vue&type=template&id=05295344"
import script from "./ClientesAdmin.vue?vue&type=script&lang=js"
export * from "./ClientesAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__